import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { EmailVerifiedSuccessComponent } from './pages/admin/auth/email-verified-success/email-verified-success.component';
import { EmailAlreadyVerifiedComponent } from './pages/admin/auth/email-already-verified/email-already-verified.component';
import { ExpiredLinkComponent } from './pages/admin/auth/expired-link/expired-link.component';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./pages/admin/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'home',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/admin/home/home.module').then(m => m.HomeModule)
      }
    ]
  },
  {
    path: 'email-verified-success',
    component: EmailVerifiedSuccessComponent,
    loadChildren: () => import('./pages/admin/auth/email-verified-success/email-verified-success.module').then(m => m.EmailVerifiedSuccessModule)
  },
  {
    path: 'email-already-verified',
    component: EmailAlreadyVerifiedComponent,
    loadChildren: () => import('./pages/admin/auth/email-already-verified/email-already-verified.module').then(m => m.EmailAlreadyVerifiedModule)
  },
  {
    path: 'expired-link',
    component: ExpiredLinkComponent,  
    loadChildren: () => import('./pages/admin/auth/expired-link/expired-link.module').then(m => m.ExpiredLinkModule)  
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: "enabled"
  //scrollPositionRestoration: "enabled"
};
@NgModule({
  imports: [
    PagesModule,
    SharedModule,
    RouterModule.forRoot(routes, routerOptions),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
